export default __webpack_public_path__ + "static/media/Manrope-ExtraBold.416b7dd6.ttf";